import { render, staticRenderFns } from "./MbGallery.vue?vue&type=template&id=9142a5ba&scoped=true&"
import script from "./MbGallery.vue?vue&type=script&lang=js&"
export * from "./MbGallery.vue?vue&type=script&lang=js&"
import style0 from "./MbGallery.vue?vue&type=style&index=0&id=9142a5ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9142a5ba",
  null
  
)

export default component.exports